<script lang="ts">
  interface Props {
    title: string;
    description?: string;
    ogImage?: string;
    canonicalUrl?: string;
  }

  let {
    title,
    description = 'Deploy a complete AI foundation into your cloud in 30 minutes. Connect your data, build agents for your workflows, and shape AI to how your business actually works.',
    ogImage = 'https://getcorral.ai/shared/images/og-socialshare.png',
    canonicalUrl
  }: Props = $props();
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />

  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:image" content={ogImage} />
  {#if canonicalUrl}
    <meta property="og:url" content={canonicalUrl} />
    <link rel="canonical" href={canonicalUrl} />
  {/if}

  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content={ogImage} />
</svelte:head>
